

















import {Component, Inject, Mixins} from 'vue-property-decorator';
import EditDialogMixin from '@/mixins/dialog/EditDialogMixin';
import CEditDialog from '@/components/base/dialog/CEditDialog.vue';
import CSelect from '@/components/base/select/CSelect.vue';
import CDatepicker from '@/components/base/datepicker/CDatepicker.vue';
import CTable from '@/components/base/table/CTable.vue';
import CNumberField from '@/components/base/numberField/CNumberField.vue';
import CCheckbox from '@/components/base/checkbox/CCheckbox.vue';
import {AxiosPromise, CancelTokenSource} from 'axios';
import WarehouseVeneerAuditEditDialogContent from '@/views/journals/warehouseVeneerAudit/WarehouseVeneerAuditEditDialogContent.vue';
@Component({
    components: {
        WarehouseVeneerAuditEditDialogContent,
        CCheckbox,
        CNumberField,
        CTable,
        CDatepicker,
        CSelect,
        CEditDialog,
    },
})
export default class WarehouseVeneerAuditEditDialog extends Mixins(EditDialogMixin) {
    @Inject() getVocabulary!: Function;
    private vocabulary: Map<string, Map<number, string>> | null = null;

    async openAsync(request: AxiosPromise, cancelRequest: CancelTokenSource, options: any) {
        this.dialog = true;
        this.cancelRequest = cancelRequest;
        this.options = options;
        const timerId = setTimeout(() => {
            this.loading = true;
        }, 100);
        try {
            const response = await Promise.all([request, this.getVocabulary(this)]);
            this.vocabulary = response[1];
            this.init(response[0].data);
        } catch (err) {
            console.log(err);
            this.close();
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }
}
